export const CREATE_TASK_MUTATION = `
  mutation CreateTask($object: tasks_insert_input!) {
    insert_tasks_one(object: $object) {
      id
      task_title
      task_description
      task_start_date
      task_due_date
      task_status
      firm_id
      company_id
      created_by
      created_at
      updated_at
      firm {
        id
        firm_name
        firm_short_name
      }
      company {
        id
        name
      }
      user {
        id
        first_name
        last_name
      }
    }
  }
`;

export const UPDATE_TASK_MUTATION = `
  mutation UpdateTask($id: Int!, $set: tasks_set_input!) {
    update_tasks_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      task_title
      task_description
      task_start_date
      task_due_date
      task_status
      firm_id
      company_id
      created_by
      created_at
      updated_at
      firm {
        id
        firm_name
        firm_short_name
      }
      company {
        id
        name
      }
      user {
        id
        first_name
        last_name
      }
    }
  }
`;

export const DELETE_TASK_MUTATION = `
  mutation DeleteTask($id: Int!) {
    delete_tasks_by_pk(id: $id) {
      id
      task_title
    }
  }
`;
